import React, { useEffect, useState } from "react";
import "./Cart_Products_card.css";
import { Table, Modal } from "react-bootstrap";
import Increment_decrement_btn_holder from "../../common-components/common_btn/increment_decrement_btn_holder/Increment_decrement_btn_holder";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import Increment_decrement_btn_holder_add from "../../common-components/common_btn/increment_decrement_btn_holder/Increment_decrement_btn_holder_add";
import { deleteAllCart, getAllCart } from "../../../features/cart/cartSlice";
import { useDispatch, useSelector } from "react-redux";
import { encodeId, variant_type, getVariantImage } from "../../../utils/common";
import Success_Modal from "../../common-components/common_modal/success_modal/Success_Modal";

function Cart_Products_card({ data, instock, setInstock }) {
  const isSignin = useSelector((state) => state.auth.is_signin);
  const dispatch = useDispatch();
  const [error, setError] = useState("");

  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [selectedCartItem, setSelectedCartItem] = useState(null);

  const deleteCart = async (id, product_id, varient_id) => {
    const res = await dispatch(
      deleteAllCart({ id, isSignin, product_id, varient_id }),
    );
    if (res.meta?.requestStatus === "fulfilled") {
      await dispatch(getAllCart(isSignin));
    } else if (res.meta?.requestStatus === "rejected") {
      console.log("Error:", res.payload || "Not In Cart");
    }
  };

  const handleRemoveClick = (val) => {
    setSelectedCartItem(val);
    setShowRemoveModal(true);
  };

  const handleConfirmRemove = async () => {
    if (!selectedCartItem) return;

    const res = await dispatch(
      deleteAllCart({
        id: selectedCartItem.id,
        isSignin,
        product_id: selectedCartItem.product_id,
        varient_id: selectedCartItem.variant_id,
      }),
    );

    if (res.meta?.requestStatus === "fulfilled") {
      setShowRemoveModal(false);
      setSelectedCartItem(null);

      await dispatch(getAllCart(isSignin));

      setShowSuccessModal(true);
    } else {
      console.log("Error:", res.payload || "Unable to remove item");
    }
  };
  const navigate = useNavigate();
  useEffect(() => {
    if (data?.data?.length > 0) {
      const anyOutOfStock = data.data.some((val) => {
        let stock = 0;

        if (
          Number(val?.Product?.variant_type_id) === Number(variant_type.Single)
        ) {
          stock = Number(val?.Product_Variant?.general_stock);
        } else if (
          Number(val?.Product?.variant_type_id) === Number(variant_type.Double)
        ) {
          stock = Number(val?.Double_Variant?.stock);
        } else if (
          Number(val?.Product?.variant_type_id) === Number(variant_type.Triple)
        ) {
          stock = Number(val?.Triple_Variant?.stock);
        }

        const quantity = Number(val?.quantity);

        return stock < quantity;
      });

      setInstock(anyOutOfStock);
    } else {
      setInstock(false);
    }
  }, [data]);

  const currentCurrency = useSelector((state) => state.master.currentCurrency);
  const rate = Number(currentCurrency?.rate) || 1;
  const symbol = currentCurrency?.symbol || "₹";
  return (
    <>
      <section className="Cart_Products_card">
        <div className="container-fluid">
          <div className="ContinueShopping_text">
            <Link to={"/categories"}>
              <p>Continue Shopping</p>
            </Link>
          </div>
          <div className="desktop_viw_table_holder">
            <div className="table-responsive">
              <Table>
                <thead>
                  <tr>
                    <th>Product</th>
                    <th className="text-center">Quantity</th>
                    <th className="text-end">
                      <b>Total</b>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.data?.length > 0 ? (
                    data.data.map((val) => {
                      let stock;
                      if (
                        Number(val?.Product?.variant_type_id) ===
                        Number(variant_type.Single)
                      ) {
                        stock = Number(val?.Product_Variant?.general_stock);
                      } else if (
                        Number(val?.Product?.variant_type_id) ===
                        Number(variant_type.Double)
                      ) {
                        stock = Number(val?.Double_Variant?.stock);
                      } else if (
                        Number(val?.Product?.variant_type_id) ===
                        Number(variant_type.Triple)
                      ) {
                        stock = Number(val?.Triple_Variant?.stock);
                      }
                      const isInstock = stock <= val?.quantity;
                      const isInstockerror = stock < val?.quantity;
                      setInstock(isInstockerror);
                      const quantity = Number(val?.quantity);

                      const mrp = Number(
                        val.Triple_Variant?.mrp ||
                          val.Double_Variant?.mrp ||
                          val.Product_Variant?.mrp,
                      );

                      const price = Number(
                        val.Triple_Variant?.price ||
                          val.Double_Variant?.price ||
                          val.Product_Variant?.price,
                      );

                      const finalmrp = Number(mrp * rate).toFixed(2);
                      const finalprice = Number(price * rate).toFixed(2);

                      return (
                        <tr
                          key={val.id ?? `${val.product_id}-${val.variant_id}`}
                        >
                          <td>
                            <div className="row">
                              <div
                                className="col-md-4 col-12"
                                onClick={() =>
                                  navigate(
                                    `/product-details/${encodeId(
                                      val.product_id,
                                    )}`,
                                  )
                                }
                                style={{ cursor: "pointer" }}
                              >
                                <div className="img_holder">
                                  <img
                                    className="Product_img"
                                    src={getVariantImage(val)}
                                    alt={val.Product?.name || "Product image"}
                                  />
                                </div>
                              </div>
                              <div className="col-md-8 col-12">
                                <div className="info_text_holder">
                                  <div>
                                    <h4>{val.Product?.name}</h4>
                                    <p className="price_text">
                                      {symbol} {finalprice}
                                      <span>
                                        {symbol} {finalmrp}
                                      </span>
                                    </p>
                                    <h6>
                                      {val?.Product?.variant_type_id ===
                                        variant_type.Single && (
                                        <>
                                          <b>
                                            <strong className="text_bold_holder">
                                              {val?.Product?.variant_name ||
                                                "Color"}
                                              :
                                            </strong>{" "}
                                          </b>
                                          {val?.Product_Variant?.Metal?.name}
                                        </>
                                      )}

                                      {val?.Product?.variant_type_id ===
                                        variant_type.Double && (
                                        <>
                                          <b>
                                            <strong className="text_bold_holder">
                                              {val?.Product?.variant_name ||
                                                "Color"}
                                              :
                                            </strong>{" "}
                                          </b>
                                          {
                                            val?.Double_Variant?.Product_Variant
                                              ?.Metal?.name
                                          }
                                          ,
                                          <b>
                                            <strong className="text_bold_holder">
                                              {" "}
                                              Size:
                                            </strong>{" "}
                                          </b>
                                          {val?.Double_Variant?.Size?.name}{" "}
                                        </>
                                      )}

                                      {val?.Product?.variant_type_id ===
                                        variant_type.Triple && (
                                        <>
                                          {/* <strong>Metal:</strong>{" "}
                                          {
                                            val?.Triple_Variant?.Double_Variant
                                              ?.Product_Variant?.Metal?.name
                                          }
                                          ,  */}
                                          <b>
                                            <strong className="text_bold_holder">
                                              {" "}
                                              Size:
                                            </strong>{" "}
                                          </b>
                                          {
                                            val?.Triple_Variant?.Double_Variant
                                              ?.Size?.name
                                          }
                                          ,{" "}
                                          <b>
                                            <strong className="text_bold_holder">
                                              {" "}
                                              Diamond:
                                            </strong>{" "}
                                          </b>
                                          {val?.Triple_Variant?.Diamond?.name}
                                        </>
                                      )}
                                      {/* Metal:{" "}
                                      <span>
                                        {val?.Product_Variant?.Metal?.name ||
                                          val?.Double_Variant?.Product_Variant
                                            ?.Metal?.name ||
                                          val?.Triple_Variant?.Double_Variant
                                            ?.Product_Variant?.Metal?.name}
                                      </span> */}
                                    </h6>

                                    {instock && isInstockerror && (
                                      <p className="text-danger mt-2">
                                        Out of stock (Available: {stock})
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>

                          <td>
                            <div className="Quantity_tr_holder justify-content-center">
                              <Increment_decrement_btn_holder_add
                                val={val}
                                quantity={val.quantity}
                                setInstock={setInstock}
                                setError={setError}
                                error={error}
                                isInstock={isInstock}
                                onRemoveClick={handleRemoveClick}
                              />

                              <FontAwesomeIcon
                                className="trash_icon"
                                icon={faTrashCan}
                                onClick={() =>
                                  deleteCart(
                                    val.id,
                                    val.product_id,
                                    val.variant_id,
                                  )
                                }
                              />
                              {/* {isInstock && error && (
                                <p
                                  style={{ color: "red" }}
                                >{`Only ${stock} quantity in stock`}</p>
                              )} */}
                            </div>

                            {isInstock && error && (
                              <p
                                style={{
                                  color: "red",
                                  textAlign: "center",
                                  marginTop: "10px",
                                }}
                              >{`Only ${stock} quantity in stock`}</p>
                            )}
                          </td>

                          <td>
                            <div className="price_holder">
                              <p className="price_text">
                                {symbol}{" "}
                                {Number(
                                  finalprice * Number(val.quantity),
                                ).toFixed(2)}{" "}
                                <span>
                                  {symbol}{" "}
                                  {Number(
                                    finalmrp * Number(val.quantity),
                                  ).toFixed(2)}
                                </span>
                              </p>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={3} className="text-center">
                        No Data Available
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>

          <div className="mobile_view_table_holder">
            {data?.data?.map((val, index) => {
              let stock;
              if (
                Number(val?.Product?.variant_type_id) ===
                Number(variant_type.Single)
              ) {
                stock = Number(val?.Product_Variant?.general_stock);
              } else if (
                Number(val?.Product?.variant_type_id) ===
                Number(variant_type.Double)
              ) {
                stock = Number(val?.Double_Variant?.stock);
              } else if (
                Number(val?.Product?.variant_type_id) ===
                Number(variant_type.Triple)
              ) {
                stock = Number(val?.Triple_Variant?.stock);
              }
              const isInstock = stock <= val?.quantity;
              const isInstockerror = stock < val?.quantity;
              const quantity = Number(val?.quantity);
              // ✅ get mrp & price for each item
              const mrp = Number(
                val?.Product_Variant?.mrp ||
                  val?.Double_Variant?.mrp ||
                  val?.Triple_Variant?.mrp ||
                  0,
              );

              const price = Number(
                val?.Product_Variant?.price ||
                  val?.Double_Variant?.price ||
                  val?.Triple_Variant?.price ||
                  0,
              );

              // ✅ convert with currency rate
              const finalmrp = `${symbol} ${(mrp * rate).toFixed(2)}`;
              const finalprice = `${symbol} ${(price * rate).toFixed(2)}`;

              return (
                <div className="mobile_product_card" key={index}>
                  <div className="commmon_product_holder">
                    <div className="left_div">
                      <div className="img_holder">
                        <img
                          src={getVariantImage(val)}
                          className="prod_img"
                          alt="product"
                        />
                      </div>
                    </div>

                    <div className="right_div">
                      <div className="descn_holder">
                        <p className="product_name">{val?.Product?.name}</p>

                        {/* ✅ price display */}
                        <p className="price_text">
                          {finalprice}
                          <span className="mrp_text">{finalmrp}</span>
                        </p>

                        <p className="weight_text">
                          Size:
                          <span>
                            {val?.Product_Variant?.Metal?.name ||
                              val?.Double_Variant?.Product_Variant?.Metal
                                ?.name ||
                              val?.Triple_Variant?.Double_Variant
                                ?.Product_Variant?.Metal?.name}
                          </span>
                        </p>

                        <div className="all_btns_holder">
                          <div className="Quantity_tr_holder">
                            <Increment_decrement_btn_holder_add
                              val={val}
                              quantity={val.quantity}
                              setInstock={setInstock}
                              setError={setError}
                              error={error}
                              isInstock={isInstock}
                              onRemoveClick={handleRemoveClick}
                            />

                            <FontAwesomeIcon
                              className="trash_icon"
                              icon={faTrashCan}
                              onClick={() =>
                                deleteCart(
                                  val?.id,
                                  val?.product_id,
                                  val?.variant_id,
                                )
                              }
                            />

                            {isInstock && error && (
                              <p
                                style={{ color: "red" }}
                              >{`Only ${stock} quantity in stock`}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <Modal
        show={showRemoveModal}
        onHide={() => setShowRemoveModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "white" }}>Remove Item</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Are you sure you want to remove this item from your cart?
        </Modal.Body>

        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setShowRemoveModal(false)}
          >
            No
          </button>

          <button
            type="button"
            className="btn btn-danger"
            onClick={handleConfirmRemove}
          >
            Yes
          </button>
        </Modal.Footer>
      </Modal>

      <Success_Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        successText="Removed from cart successfully"
      />
    </>
  );
}

export default Cart_Products_card;
